export enum AdminSortEnum {
  name = 1,
  lastName ,
  status,
  role
}